import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ContentCategoryAdminResponse } from './types';

export async function createContentCategory(name: string) {
  const url = '/web/studio/content-categories';

  const response = await api.executePostRequest<ObjectResponse<ContentCategoryAdminResponse>>(url, { name });

  return response.data;
}
